import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Menubar } from 'primereact/menubar';
import { Title } from 'components/Title';

import InterestPosting from '../interest/InterestPosting';
import PostingHistory from '../interest/PostingHistory';
export default function InterestpostingPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [refreshKey, setRefreshKey] = useState(0);
	return (
		<main id="InterestpostingPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('interestposting')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="min-h-screen surface-100">
                        <Menubar start={
                        <span className="font-bold text-xl">
                        <i className="pi pi-wallet mr-2" /> Savings Interest
                        </span>
                        } />
                        <div className="p-4 max-w-6xl mx-auto">
                            <InterestPosting onPosted={() => setRefreshKey(k => k + 1)} />
                            <PostingHistory refreshKey={refreshKey} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
